import PropTypes from 'prop-types';

import {
  BaseDefaultProps,
  BasePropTypes,
} from '@/common/proptypes/Base/Base.proptypes';

export const TextInputDefaultProps = {
  ...BaseDefaultProps,
  autoComplete: 'off',
  errors: false,
  id: null,
  max: null,
  maxLength: null,
  min: null,
  minLength: null,
  name: '',
  onBlur: () => null,
  onChange: () => null,
  onClick: () => null,
  onFocus: () => null,
  onKeyDown: () => null,
  placeholder: '',
  readOnly: false,
  required: false,
  revealed: false,
  spellCheck: false,
  type: 'text',
  value: '',
  variant: null,
};

export const TextInputPropTypes = {
  ...BasePropTypes,
  autoComplete: PropTypes.string,
  errors: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.number,
  maxLength: PropTypes.number,
  min: PropTypes.number,
  minLength: PropTypes.number,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  revealed: PropTypes.bool,
  spellCheck: PropTypes.bool,
  type: PropTypes.oneOf([
    'date',
    'email',
    'hidden',
    'number',
    'password',
    'search',
    'tel',
    'text',
    'time',
    'url',
  ]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  variant: PropTypes.string,
};
